// plugins/vue-ls.js
import Vue from 'vue';
import VueLs from 'vue-ls';

Vue.use(VueLs, {
  namespace: 'yuanzhu_', // 本地存储的命名空间
  name: 'ls', // 挂载到 Vue 实例上的属性名
  storage: 'local', // 默认使用 localStorage, 你可以选择 'session' 或 'local'
});
